// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_REVIEW_FOR_STROLLER_SALE_FASTER = "r\u00fdchlej\u0161ie pred\u00e1vaj\u00fa";
export const ADD_REVIEW_FOR_STROLLER_TO_BOOST_SALE_stroller_boost = "Pridaj hodnotenie ko\u010d\u00edka %(stroller)s. Ko\u010d\u00edky s hodnoten\u00edm sa %(boost)s. Naviac pom\u00f4\u017ee\u0161 ostatn\u00fdm mami\u010dk\u00e1m vo v\u00fdbere.";
export const STROLLER_ADD_REVIEW = "Pridaj hodnotenie";
export const STROLLER_BRAND = "Zna\u010dka";
export const STROLLER_INFO_MORE_ABOUT_model = "Viac o %(model)s v Ko\u010d\u00edkop\u00e9dii";
export const STROLLER_INFO_SHOW_REVIEWS = "Zobrazi\u0165 hodnotenia";
